<eds-panel
  class="list-details"
  [hasBorders]="true"
  [hasPadding]="true"
  edsSpacing="lg"
  theme="white"
>
  <eds-section-header
    theme="primary"
    size="h5"
    [title]="panelData.title"
    [level]="5"
    edsSpacing="md"
    [asOfLabel]="'products.as-of' | translate"
    [asOfDate]="panelData.asOfDate"
    [updateFrequency]="updateFrequency"
    [caveatPlacement]="panelData.footnote"
    [analyticsName]="panelData?.title"
    [tooltip]="panelData.tooltip"
    [analyticsName]="panelData?.analyticsName"
  >
  </eds-section-header>
  <ng-container *ngIf="panelData.twoColumn; else oneCol">
    <div edsCssCols edsSubGrid="layout-1" colGap="xxl">
      <eds-info-item
        *ngFor="let item of dataColumns"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>
  </ng-container>
  <ng-template #oneCol>
    <div>
      <eds-info-item
        *ngFor="let item of dataColumns"
        [info]="item"
        edsSpacing="xs"
        labelValueSplit="60-40"
      >
      </eds-info-item>
    </div>
  </ng-template>
</eds-panel>
